export default interface ICadReportsBi {
  id: number;
  access_key: string;
  id_license: string;
  id_company: string;
  company: string;
  id_usuario: string;
  usuario: string;
  desc_modulo: string;
  desc_menu: string;
  desc_relatorio: string;
  url_power_bi: string;
  report_section_power_bi: string;
  obs: string;
  inf1: string;
  inf2: string;
  inf3: string;
  inf4: string;
  inf5: string;
  acao: string;
  created_at: Date | undefined;
  updated_at: Date | undefined;
}

export const emptyCadReportsBi: ICadReportsBi = {
  id: 0,
  access_key: '',
  id_license: '',
  id_company: '',
  company: '',
  id_usuario: '',
  usuario: '',
  desc_menu: '',
  desc_modulo: '',
  desc_relatorio: '',
  url_power_bi: '',
  report_section_power_bi: '',
  obs: '',
  inf1: '',
  inf2: '',
  inf3: '',
  inf4: '',
  inf5: '',
  acao: '',
  created_at: undefined,
  updated_at: undefined,
};
